import { jsx as _jsx } from "react/jsx-runtime";
import { useField } from 'formik';
import { withJsonFormsCellProps } from '@jsonforms/react';
import { rankWith, schemaTypeIs, } from '@jsonforms/core';
import { InputField } from '../Ui/InputField/InputField';
var FormikCompatibleInputInner = function (props) {
    var _a;
    var schema = props.schema, uischema = props.uischema, key = props.key;
    // @ts-ignore
    var _b = useField("".concat(uischema.orderItem, "[").concat(uischema.iteration, "].").concat(uischema.name)), field = _b[0], meta = _b[1];
    return (_jsx(InputField, { initialValue: field.value, label: uischema.label, fieldName: field.name, handleChange: field.onChange, error: meta.error, 
        // @ts-ignore
        isRequired: (_a = schema.required) === null || _a === void 0 ? void 0 : _a.includes(uischema.name) }, key));
};
// @ts-ignore
export var FormikCompatibleInput = withJsonFormsCellProps(FormikCompatibleInputInner);
export var formikCompatibleControlTester = rankWith(3, // increase rank as needed
schemaTypeIs('string'));
